import '../../modules/mode-components';

import * as angular from 'angular';
import { debounce } from 'lodash';

const halTextValidator = function ($q) {
  return {
    scope: {
      halValidation: '<',
      halPropertyPath: '@',
      halCurrent: '@',
    },
    require: 'ngModel',
    link: function (scope, elm, attrs, ngModel) {
      // debounce inside the validator instead of in ngModelOptions so angular will immediately set $pending to true so we can disable submit
      const validate = debounce(function (deferred, modelValue) {
        const lastIndex = scope.halPropertyPath.lastIndexOf('.');
        const link = scope.halPropertyPath.replace('.', '_');
        const indexProperty = `${scope.halPropertyPath.substring(0, lastIndex)}[${scope.halPropertyPath.substring(
          lastIndex + 1
        )}]`;

        scope.halValidation._resource
          .links('validate_' + link)
          .$follow({ [indexProperty]: modelValue })
          .then((response) => {
            ngModel.$setValidity('networkError', true);
            ngModel.$setValidity('halFailed', response.valid);

            if (response.valid) {
              deferred.resolve();
            } else {
              deferred.reject(response.errors.name[0]);
            }
          })
          .catch((response) => {
            ngModel.$setValidity('networkError', false);
            deferred.reject(new Error('Error validating definition name'));
          });
      }, 350);

      function validateName(modelValue, viewValue) {
        const deferred = $q.defer();

        if (ngModel.$isEmpty(modelValue) || modelValue === scope.halCurrent) {
          ngModel.$setValidity('networkError', true);
          // consider empty models to be valid
          deferred.resolve();
        } else {
          validate(deferred, modelValue);
        }

        return deferred.promise;
      }

      ngModel.$asyncValidators.halFailed = validateName;
    },
  };
};

halTextValidator.$inject = ['$q'];

angular.module('mode.components').directive('halValidation', halTextValidator);
